import React from "react";
import "../styles/Contact.css";

function Contact() {
  return (
    <div className="contact-main">
      <div className="contact-container">
        <h1>Contact Us</h1>
        <p>
          <b>Office:</b> 32, Saroday Colony, Nr. New City High School, Dhule – 424001<br />
          <b>Campus:</b> Songir Highway Road, Dhule<br />
          <b>Email:</b> <a href="mailto:sarojinicollegeofnursing@gmail.com">sarojinicollegeofnursing@gmail.com</a><br />
          <b>Phone:</b> 02562-238754<br />
          <b>Mobile:</b> 8275122933, 8275122944
        </p>
        <h2>Reach us on Social Media</h2>
        <div className="contact-social-row">
          <a href="https://facebook.com/" target="_blank" rel="noopener noreferrer" className="contact-social-btn contact-fb">Facebook</a>
          <a href="https://instagram.com/" target="_blank" rel="noopener noreferrer" className="contact-social-btn contact-ig">Instagram</a>
          <a href="https://linkedin.com/" target="_blank" rel="noopener noreferrer" className="contact-social-btn contact-ln">LinkedIn</a>
        </div>
      </div>
    </div>
  );
}

export default Contact;